import { React, useEffect } from "react";
import { useFaqs } from "../../../hooks/apis/main";

function Faq_questions() {
  const { data, isLoading, error } = useFaqs();
  const HandleFaq = (e) =>{
    let fs = document.getElementsByClassName('.q');
    while (fs.length) {
      fs[0].classList.remove("someStyle");
      
    }
    e.target.closest('.q').classList.add('active');
  }

  const faqs = data?.data?.faqs;
  return (
    <div className="faq-content">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-8 col-12">
            <div className="faq-questions">
              {faqs?.map((item, index) => (
                <div className="q" key={index}>
                  <h2 className="q__title" onClick={HandleFaq}>
                    {item.question}
                    <i className="fas fa-angle-down"></i>
                  </h2>
                  <div className="q__answer">{item.answer}</div>
                </div>
              ))}
            </div>
          </div>
          <div className="col-lg-4 col-12">
              <img src={process.env.PUBLIC_URL + '/images/faq.png'} alt="سوالات متداول" title="سوالات متداول" className="img-fluid"/>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Faq_questions;
